let BaseSKU;
let responseText;
let limitedSkus = ['EG1580-BLK-SM', 'EG1580-BLK-2XL', 'EG1507-STGR-LG', 'EG1576-STGR-MD', 'EG5576-NAVY-XS', 'EG5512-STGR-LG', 'EG5512-STGR-XL', 'EG5512-STGR-2XL', 'EG1512-NAVY-MD', 'EG1512-NAVY-XL', 'EG1512-NAVY-2XL', 'EG1512-STGR-XL'];

/*** This function creates a mutation observer on a specified element with a specified callback function ***/
function StartDomMutationObserver(element, callback, _config = {attributes: true, childList: true, subtree: true}){
  let config = _config;
  const observer = new MutationObserver(callback);
  observer.observe(element, config);
}
/*** Gets all options on the page and adds a Mutation observer or a event listener ***/
const GetAllOptions = () => {
  let options = document.querySelectorAll(".mw-option__value"); //Get All option Elements
  let newParent = [];
  for(let option of options){
    if(option.className.includes("mw-text")){ //if the option element includes this text
      if(!newParent.includes(option.parentElement)){ // and we dont have the option elements parent stored already
        newParent.push(option.parentElement); //Push the parent into the array
      }
    }else{
      StartDomMutationObserver(option, MainUpdateHandler, {attributes:true, childList:false}); //if it doesnt have that text then Start a observer on that element
    }
  }
  for(let ele of newParent){
    ele.addEventListener("change", (e) => { //Ele loop through the parent elements we got and add a listener for change
      MainUpdateHandler();
    });
  }
}


/*** Check if there is a only a single options and it is required ***/
const CheckForSingleRequired = () => {
  //if we dont have any response text then return
  if(!responseText){
    return;
  }
  const option_Wrappers = Object.keys(responseText.options); //Get the option keys from APO

  for(let o_name of option_Wrappers){
    const current_option = responseText.options[o_name]; //Get the current options using the option key
    if(current_option.input_type === "select"){
      continue;
    }
    let ValueCount = current_option.values.length;
    let isRequired = current_option.is_required;
    if(ValueCount > 1 || !isRequired){ //If the amount of options is more than 1 and it is not required then we can skip this set of options
      continue;
    }
    const optionName = current_option.values[0]; //Get the name
    let option_element = this.document.getElementById(optionName); //Use the name as the id to get the element
    if(!option_element.className.includes("mw-option__value--selected") && !option_element.disabled){ //If it is not selected then click the element
      option_element.click();
    }
  }
}
/*** This gets APO data and the base sku ***/
function MainUpdateHandler(){
  let APO_Object = responseText; //This is all APO data that is passed to a web page

  let values = APO_Object.values;
  let values_keys = Object.keys(values);
  let SKUS = [];


  for(let key of values_keys){
    if(values[key].enabled === true && values[key].value.inventory.sku !== ""){ //If its enabled and the sku isn't empty
      SKUS.push(values[key].value.inventory.sku) //addd the sku to a aarray
    }
  }
  if(SKUS.length > 0){
    let skuele = document.getElementsByClassName("product-single__sku"); // this element is the parent to the span that contains the sku
    for(let sku of skuele){
       let skuCompiled = (BaseSKU + "-" + SKUS.map((s, i) => { //Set the skus innerhtml equal to the basesku + a dash + the sku array returned as a string
        if(i === SKUS.length-1){
          return s.replace(/ /g, ""); //Replace white space
        }
        return s.replace(/ /g, "") + "-"; //Replace white space and place a dash
      })).replace(/,/g, ""); //Remove all periods
      sku.children[0].innerHTML = skuCompiled;
      // console.log(skuCompiled)
      let clearText = true;
      limitedSkus.forEach((limSku) => {
        // console.log(skuCompiled+"__"+limSku)
        if(limSku.length > 0 && skuCompiled.includes(limSku, 4)) {
          document.getElementById("js-limited-product-message").innerHTML = "<div style='color:red; margin-bottom: 15px;'>Limited quantity remaining!</div>";
          // console.log('YES');
          clearText = false;
        }
        if(clearText){
          document.getElementById("js-limited-product-message").innerHTML = "";
        }
      });

    }

  }
}
//This gets all basic data needed for rest of the script
function UpdateMain(){
  if(!meta.product){
    return;
  }
  const variants = meta.product.variants; // get variants from apo
  let VariantId = -1;

  for(let v of variants){ //Find any variants that include Default Title
    if(!v.name.includes("Default Title")){
      VariantId = v.id;
    }
  }

  if(!window.mwApoInit.response){ //If mwapoinit.response doesnt exist then return
    return;
  }
  /* This gets the base sku, the sku that doesn't have any options */
  let skuele = document.getElementsByClassName("product-single__sku"); // this element is the parent to the span that contains the sku
  /* if we didnt find any base sku the we will use the product handle as the sku just so that it is fulled with something */
  if(skuele.length > 0){
    for(let sku of skuele){
      BaseSKU = sku.children[0].innerHTML
    }
  }else{
    BaseSKU = window.mwApoInit.product.handle.toUpperCase(); //Get the product handle and uppercase it
  }

  // BaseSKU = window.mwApoInit.product.handle.toUpperCase();
  responseText = window.mwApoInit.response[VariantId];
  MainUpdateHandler();
}

/**** We wait for the window to finish loading before we start our timer ****/
window.addEventListener('load', () => {
  let updateTimer = setInterval(() => {
    UpdateMain();
    GetAllOptions();
    CheckForSingleRequired();
    if(window.mwApoInit.is_used){
      clearInterval(updateTimer);
    }
  }, 250);
});